import { useState, useEffect } from "react";
import CreateDeal from "../../../components/modals/CreateDeal";
import useAppDataStore from "../../../../states/useAppDataStore";
import UpdateDealModal from "../../../components/modals/UpdateDealModal";

function DealsTab({ contactId, contact, relatedDeals = [], dealsLoading = false, dealsError = "", onRefreshTabData, panelActionRequest }) {
    const products = useAppDataStore((state) => state.products);
    const productsLoading = useAppDataStore((state) => state.productsLoading);
    const productsError = useAppDataStore((state) => state.productsError);

    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedDeal, setSelectedDeal] = useState(null);

    const [localDeals, setLocalDeals] = useState(relatedDeals);
    useEffect(() => {
        setLocalDeals(relatedDeals);
    }, [relatedDeals]);

    const handleDeleteDeal = (dealId) => {
        setLocalDeals(localDeals.filter((deal) => deal.id !== dealId));
        onRefreshTabData?.();
        console.log(relatedDeals[0]);
    }

    useEffect(() => {
        if (panelActionRequest?.type === "Create Deal") {
            setIsCreateOpen(true);
        }
    }, [panelActionRequest?.nonce]);

    return (
        <section className="tab-panel-container" aria-label="Related deals">
            <div className="tab-panel-header">
                <div>
                    <h3>Related Deals</h3>
                    <p className="tab-panel-subtitle">
                        • {localDeals.length > 0 ? `${localDeals.length} Active Deal${localDeals.length > 1 ? "s" : ""}` : "Active Deal"}
                    </p>
                </div>
                <div className="tab-panel-actions">
                    <button
                        type="button"
                        className="tab-panel-btn tab-panel-btn--primary"
                        onClick={() => setIsCreateOpen(true)}
                    >
                        Create Deal +
                    </button>
                    <button
                        type="button"
                        className="tab-panel-btn tab-panel-btn--primary"
                        title="Open Deal action will be wired later"
                    >
                        Open Deal
                    </button>

                </div>
            </div>

            <table className="tab-panel-table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Stage</th>
                        <th>Product</th>
                        <th>Value</th>
                        <th>Owner</th>
                        <th>Last Activity</th>
                        <th className="tab-panel-table__actions-head">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {dealsLoading ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">Loading deals...</td>
                        </tr>
                    ) : dealsError ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">{dealsError}</td>
                        </tr>
                    ) : relatedDeals.length === 0 ? (
                        <tr>
                            <td colSpan={7} className="tab-panel-empty">No related deals yet.</td>
                        </tr>
                    ) : (
                        relatedDeals.map((deal) => (
                            <tr key={String(deal.id)}>
                                <td>{deal.title || deal.deal_name || "-"}</td>
                                <td>{deal.stage || deal.deal_stage || "-"}</td>
                                <td>{deal.product_name || "-"}</td>
                                <td>{deal.amount_cents ? `$${(Number(deal.amount_cents) / 100).toLocaleString()}` : (deal.deal_value ? `$${Number(deal.deal_value).toLocaleString()}` : "-")}</td>
                                <td>{deal.owner_name || "-"}</td>
                                <td>{deal.updated_at ? new Date(deal.updated_at).toLocaleDateString() : "-"}</td>
                                <td>
                                    <div className="tab-panel-row-actions">
                                        <button type="button" className="related-row-btn related-row-btn--stage">{(deal.stage || "-")}</button>
                                        <button type="button" className="related-row-btn" onClick={() => {
                                            setSelectedDeal(deal);
                                            setShowUpdateModal(true);
                                        }}>
                                            Update
                                        </button>

                                        
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {isCreateOpen && (
                <CreateDeal
                    isOpen={isCreateOpen}
                    onClose={() => setIsCreateOpen(false)}
                    contactId={contactId}
                    initialAccount={contact?.account || ""}
                    initialAccountId={contact?.account_id || contact?.accountId || null}
                    products={products}
                    productsLoading={productsLoading}
                    productsError={productsError}
                    onCreated={() => {
                    onRefreshTabData?.();
                }}
            />)}

            <UpdateDealModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                deal={selectedDeal}
                onDelete={handleDeleteDeal}
            />
        </section>
    );
}

export default DealsTab;
